import { render, staticRenderFns } from "./vNewChat.vue?vue&type=template&id=84622fb6"
import script from "./vNewChat.vue?vue&type=script&lang=js"
export * from "./vNewChat.vue?vue&type=script&lang=js"
import style0 from "./vNewChat.vue?vue&type=style&index=0&id=84622fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports